export const NAVIGATION_KEYS = {
    all: () => ['navigation'] as const,
    menu: () => [...NAVIGATION_KEYS.all(), 'menu'] as const,
};
